import DebtorsList from "pages/private/Debtors/DebtorsList";
import PaymentPlanList from "pages/private/PaymentPlan/PaymentPlanList";
import PaymentPlanCreate from "./PaymentPlan/PaymentPlanCreate";
import Dashboard from "pages/private/Dashboard";
import * as routeConfig from "Infrastructure/config/routesConfig.js";
import * as icons from "@mui/icons-material";
import ProfilePage from "./Profile";
import { hasRight } from "Application/User/UserRightsService";
import UsersList from "./User/UsersList";
import InternalUsersList from "./User/InternalUsersList";
import CreateDebtor from "./Debtors/CreateDebtor";
import EditDebtor from "./Debtors/EditDebtor";
import PaymentPlanDetails from "./PaymentPlan/PaymentPlanDetails";
import PaymentList from "./Payment/PaymentList";
import PaymentDetails from "./Payment/PaymentDetails";
import CreditorPaymentList from "./Payment/CreditorPaymentList";
import CreditorPaymentDetails from "./Payment/CreditorPaymentDetails";

function filterRoutesByRight(routes) {
  const allowedRoutes = routes.filter(
    (route) => route.action === undefined || hasRight(route.action)
  );
  if (!allowedRoutes) {
    return [];
  }
  return allowedRoutes;
}

const allMainMenu = [
  {
    key: routeConfig.HOME,
    path: routeConfig.getRoute(routeConfig.HOME),
    component: <Dashboard />,
    icon: <icons.Dashboard />,
  },
  {
    key: routeConfig.DEBTORS_LIST,
    path: routeConfig.getRoute(routeConfig.DEBTORS_LIST),
    component: <DebtorsList />,
    icon: <icons.PeopleAlt />,
    action: "debtor_search",
    children: [
      {
        key: routeConfig.CREATE_DEBTOR,
        path: routeConfig.getRoute(routeConfig.CREATE_DEBTOR),
        component: <CreateDebtor />,
        icon: <icons.PeopleAlt />,
        action: "debtor_search",
      },
      {
        key: routeConfig.DEBTOR_DETAIL,
        path: routeConfig.getRoute(routeConfig.DEBTOR_DETAIL),
        component: <EditDebtor />,
        icon: <icons.PeopleAlt />,
        action: "debtor_search",
      },
    ],
  },
  {
    key: routeConfig.PAYMENT_PLAN_LIST,
    path: routeConfig.getRoute(routeConfig.PAYMENT_PLAN_LIST),
    component: <PaymentPlanList />,
    icon: <icons.Payments />,
    action: "payment-plan_search",
    children: [
      {
        key: routeConfig.PAYMENT_PLAN_CREATE,
        path: routeConfig.getRoute(routeConfig.PAYMENT_PLAN_CREATE),
        component: <PaymentPlanCreate />,
        icon: <icons.Payment />,
        action: "payment-plan_create",
      },
      {
        key: routeConfig.PAYMENT_PLAN_DETAIL,
        path: routeConfig.getRoute(routeConfig.PAYMENT_PLAN_DETAIL),
        component: <PaymentPlanDetails />,
        icon: <icons.Payment />,
        action: "payment-plan_create",
      },
    ],
  },
  {
    key: routeConfig.CREDITOR_PAYMENT_LIST,
    path: routeConfig.getRoute(routeConfig.CREDITOR_PAYMENT_LIST),
    component: <CreditorPaymentList />,
    icon: <icons.Payment />,
    action: "creditor-payment_search",
    children: [
      {
        key: routeConfig.CREDITOR_PAYMENT_DETAIL,
        path: routeConfig.getRoute(routeConfig.CREDITOR_PAYMENT_DETAIL),
        component: <CreditorPaymentDetails />,
        icon: <icons.Payment />,
        action: "creditor-payment_get",
      },
    ],
  },
];
const allInternalMenu = [
  {
    key: routeConfig.USERS_LIST,
    path: routeConfig.getRoute(routeConfig.USERS_LIST),
    component: <UsersList />,
    icon: <icons.PeopleAlt />,
    action: "users_search",
    children: [
      {
        key: routeConfig.USER_DETAIL,
        path: routeConfig.getRoute(routeConfig.USER_DETAIL),
        component: <ProfilePage />,
        icon: <icons.Person2 />,
      },
    ],
  },
  {
    key: routeConfig.INTERNAL_USERS_LIST,
    path: routeConfig.getRoute(routeConfig.INTERNAL_USERS_LIST),
    component: <InternalUsersList />,
    icon: <icons.PeopleOutline />,
    action: "users_search",
  },
  {
    key: routeConfig.PAYMENT_LIST,
    path: routeConfig.getRoute(routeConfig.PAYMENT_LIST),
    component: <PaymentList />,
    icon: <icons.AccountBalance />,
    action: "payment_search",
    children: [
      {
        key: routeConfig.PAYMENT_DETAIL,
        path: routeConfig.getRoute(routeConfig.PAYMENT_DETAIL),
        component: <PaymentDetails />,
        icon: <icons.AccountBalance />,
        action: "payment_get",
      },
    ],
  },
];

export const ProfileLink = {
  key: routeConfig.USER_DETAIL,
  path: routeConfig.getRoute(routeConfig.USER_DETAIL),
  component: <ProfilePage />,
  icon: <icons.Person2 />,
};

export const LogoutLink = {
  key: routeConfig.LOGOUT,
  path: routeConfig.getRoute(routeConfig.LOGOUT),
  icon: <icons.Logout />,
};

export const mainMenu = () => filterRoutesByRight(allMainMenu);
export const internalMenu = () => filterRoutesByRight(allInternalMenu);
export default function getRoutes() {
  return [...mainMenu(), ...internalMenu(), ProfileLink];
}
